<template>
  <div></div>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
